import { Box, Typography } from "@mui/material";

import Card from "components/Card";
import { DefaultUrlWeb } from "config/Configuration";

export default function BoxMarginHistory({ marginHistoryItem }) {
  return (
    <Card marginBottom={15}>
      <Box
        display="flex"
        justifyContent="space-between"
        flexDirection="row-reverse"
        pb={2}
      >
        <Box display="flex" alignItems="center" flexDirection="row-reverse">
          <img
            src={DefaultUrlWeb + marginHistoryItem?.coinImageUrl}
            alt=""
            width={25}
          />
          <Typography variant="h5" color="text.main" pl={1}>
            {marginHistoryItem?.coinName}
          </Typography>
        </Box>

        <Box>
          {" "}
          <Typography fontSize="13px" color="text.main">
          {marginHistoryItem?.time} &nbsp;&nbsp;&nbsp;{marginHistoryItem?.date}
          </Typography>
        </Box>
      </Box>

      <Box display="flex" flexDirection="row-reverse" pb={2}>
        <Typography variant="h6" color="text.secondary">
          Amount
        </Typography>

        <Typography variant="h6" px={1}>
          {marginHistoryItem?.amount}
        </Typography>
      </Box>

      <Box display="flex" flexDirection="row-reverse">
        <Typography variant="h6" color="text.secondary">
          type
        </Typography>

        <Typography variant="h6" pl={1}>
          {marginHistoryItem?.type}
        </Typography>
      </Box>
    </Card>
  );
}
